import React from 'react'
import PropTypes from 'prop-types'
import { useWillPipe } from '@morningtrain/react-helpers'
import { useRouter } from '@morningtrain/react-navigation'
function RedirectOnPipe (props) {
  const router = useRouter()

  useWillPipe((payload) => {
    return new Promise((resolve, reject) => {
      router.redirectToRoute(props.routeName, props.parameters)
      Promise.resolve(payload)
    })
  })
  return null
}
RedirectOnPipe.defaultProps = {
  data: {}
}
RedirectOnPipe.propTypes = {
  routeName: PropTypes.string,
  data: PropTypes.string
}
export default RedirectOnPipe
